import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import LiveCreateProgress from '@/types/table/liveCreateProgress';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface LiveCreateProgressData extends LiveCreateProgress {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class LiveCreateProgressController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<LiveCreateProgressData>>(API_CONTEXT + '/app/liveCreateProgress/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<LiveCreateProgressData>(API_CONTEXT + '/app/liveCreateProgress/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/liveCreateProgress/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/liveCreateProgress/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/liveCreateProgress/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveCreateProgress/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveCreateProgress/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveCreateProgress/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveCreateProgress/deleteBatch', params, httpOptions);
  }
}
